export default __webpack_public_path__ + "static/media/St Benedict Medal.fe01b6a0.jpg";